<template>
  <v-container class="container-card">
    <v-card>
      <Parametros />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Parametros from "@/components/comissao/funcoesParametros/equipes/Equipe";
export default {
  components: {
    Parametros
  },
  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Funções Parâmetros Equipe");
  }
};
</script>

<style></style>
